import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import 'bootstrap-icons/font/bootstrap-icons.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import CanvaPurchase from './pages/CanvaPurchase.tsx';
import CanvaBack from './pages/CanvaBack.tsx';
import AuthLayout from './layouts/AuthLayout'; 
import EmptyLayout from './layouts/EmptyLayout';

import CanvaRoute from './components/CanvaRoute.tsx';
import { CanvaAuthProvider } from './contexts/CanvaAuthContext2.tsx';
import './App.css';

function App() {
  return (
    <HelmetProvider>
      <Router>
        <Routes>
         
		<Route element={<AuthLayout />}>
            <Route path="/canva-back" element={<CanvaBack />} />
          </Route>

          {/* CanvaRoute */}
          
          <Route element={<EmptyLayout />}>
			  <Route
				path="/canva/*"
				element={
				  <CanvaAuthProvider>
					<CanvaRoute>
					  <Routes>
						<Route path="upgrade" element={<CanvaPurchase />} />
						<Route path="manage" element={<CanvaPurchase />} />
					  </Routes>
					</CanvaRoute>
				  </CanvaAuthProvider>
				}
			  />
		</Route>

          
        </Routes>
      </Router>
    </HelmetProvider>
  );
}

export default App;
